/**
 * P15 — injeta/atualiza <link rel="manifest"> no <head> dinamicamente.
 *
 * Manifest é servido pelo backend (API_HOST), não pelo shell. Shell SPA
 * catch-all `/*  /index.html  200` pega `/api/manifest/:slug` antes do
 * backend, devolve HTML, browser trava em "Manifest syntax error".
 *
 * Solução: URL absoluta pro API. `crossorigin="use-credentials"` obrigatório
 * pra browser aceitar manifest cross-origin.
 *
 * `apiHost` opcional pra permitir uso dev (same-origin) ou injeção de teste.
 * Sem arg, default `''` (relativo — funciona só se backend responde no
 * mesmo host, não é o caso em staging/prod).
 */

export function updateManifestLink(slug: string, apiHost = ''): void {
  const base = apiHost ? `https://${apiHost.replace(/^https?:\/\//, '')}` : '';
  const href = `${base}/api/manifest/${encodeURIComponent(slug)}`;
  let link = document.getElementById('pwa-manifest') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.id = 'pwa-manifest';
    link.rel = 'manifest';
    if (apiHost) link.crossOrigin = 'use-credentials';
    document.head.appendChild(link);
  }
  link.href = href;
}
